const lang = {
  intro: {
    title: "再次探索各地精彩美饌",
    paragraph:
      "<p>《白金美饌‧非同凡饗》</p><p>立即登錄即享全球超過2,000間知名餐廳全年度最高NT$10,000餐飲抵用額度禮遇！2025年度以美國運通簽帳白金卡於台灣及海外指定餐廳用餐，各享最高NT$5,000刷卡金回饋，回饋金額度分為上半年（2025年1月7日至6月30日）及下半年（2025年7月1日至12月31日），台灣及海外指定餐廳，各NT$2,500<sup>註1</sup>，讓您盡情探索全球道地精彩美饌。</p>",
    tcLink: "參閱活動細則與注意事項",
    topBanner: {
      show: false,
      heading:
        "好消息！美國運通將於2025年1月再度推出《白金美饌‧非同凡饗》禮遇。",
      description:
        "目前您已登錄的活動禮遇有效至2024年12月31日，我們將於近期公告2025年活動登錄資訊，敬請期待！",
    },
    hotelRestaurant:
      "* 請留意，若您於指定餐廳的飯店入住時，用餐後請務必直接於餐廳以美國運通簽帳白金卡（不含其他支付工具）當場簽付，方可適用此活動。請恕併入房帳結帳者將不適用。",
  },
  filters: {
    country: "國家：",
    state: "省：",
    stateDefault: "All states",
    city: "城市：",
    cityDefault: "所有城市",
    cuisine: "料理類別：",
    cuisineDefault: "所有料理",
  },
  results: {
    halal: "清真",
    notAvailable: "此選擇不提供餐廳",
    viewmap: "顯示詳細地圖",
    makebooking: "立即預訂",
    makebookingTel: "立即預訂",
    orderOnline: "如需點餐，請瀏覽：",
    deliveryTakeaway: "提供外送和外賣",
    deliveryProvidoor: "Delivery available via Providoor",
    openingSoon: "Opening soon",
    onlineOnly: "Online Only",
    new: "全新加入",
    locations: "餐廳位置",
    button: "點選後瀏覽各分店位置",
    groupCuisine: "各種料理菜系",
    close: "關閉",
    bookNow: "立即預訂",
  },
  tsAndCs: {
    title: "遇條款及細則",
    platinum: {
      html: `<ol> <li> 僅適用於收到本活動邀請函並持有台灣美國運通發行之美國運通簽帳白金卡指定主卡會員；本活動邀請函恕轉發無效。 </li> <li> 活動期間（2025年1月7日至2025年12月31日，每一主卡帳戶於2025年1月7日至2025年6月30日期間最高可享NT$2,500「全台指定餐廳」及NT$2,500「海外指定餐廳」刷卡金回饋，2025年7月1日至2025年12月31日期間最高可享NT$2,500「全台指定餐廳」及NT$2,500「海外指定餐廳」刷卡金回饋）僅須以主卡身分登錄，刷卡金回饋將於成功登錄本活動後開始計算，登錄前之消費恕無法回溯及回饋刷卡金。本活動將合併計算美國運通簽帳白金卡主卡及其附屬卡之合資格消費，但不含主／附屬卡會員名下之其他美國運通卡。 </li> <li> 本活動適用於「全台指定餐廳」刷卡金與「海外指定餐廳」刷卡金，各自額度將適用於其指定餐廳，恕無法合併使用： <ol> <li> 活動期間，已登錄之卡會員須持有效實體卡親臨「全台指定餐廳」進行餐飲消費，單筆合資格之消費每滿NT$50可獲NT$50刷卡金回饋；不足NT$50之金額將與下一筆合資格消費金額合併計算。主、附卡消費合併計算，每一主卡帳戶於2025年1月7日至2025年6月30日期間最高可享NT$2,500「全台指定餐廳」刷卡金回饋，2025年7月1日至2025年12月31日期間最高可享NT$2,500「全台指定餐廳」刷卡金回饋，恕無法與「海外指定餐廳」刷卡金合併使用。 </li> <li> 活動期間，已登錄之卡會員須持有效實體卡親臨「海外指定餐廳」進行餐飲消費，單筆合資格之外幣消費將依當日匯率清算，並轉換為台幣計算，且月結單上同時列收該筆交易之國外交易手續費，刷卡金回饋僅折抵餐飲消費金額（不含國外交易手續費）：每滿等值NT$50可獲NT$50刷卡金回饋，不足NT$50之等值金額將與下一筆合資格消費金額合併計算。主、附卡消費合併計算，每一主卡帳戶於2025年1月7日至2025年6月30日期間最高可享NT$2,500「海外指定餐廳」刷卡金回饋，2025年7月1日至2025年12月31日期間最高可享NT$2,500「海外指定餐廳」刷卡金回饋，恕無法抵用國外交易手續費、亦無法與「全台指定餐廳」刷卡金合併使用。 </li> <li> 「全台指定餐廳」刷卡金與「海外指定餐廳」刷卡金需於當年度2025年6月30日23:59／2025年12月31日23:59（台灣時間）前使用完畢，為預留餐廳請款時間以利系統自動回饋，建議於各活動期間結束前2天完成消費。未用罄之刷卡金屆時將於2025年7月1日00:00／2026年1月1日00:00（台灣時間）失效。 </li> <li> 若刷卡交易紀錄非於指定活動期間（2025年1月7日至2025年12月31日），該筆消費將不列入刷卡金回饋計算。 </li> <li> 指定餐廳限於2024年12月31日前完成美國運通卡收卡機制設定之餐廳，餐廳配合之美食外送、預訂平台之消費、禮品卡之販售、取消或未報到之預付費用、非實體卡（含第三方交易平台）支付、海外交易手續費，或非本人親臨支付之費用皆不適用。 </li> </ol> </li> <li> 適用本活動之「全台指定餐廳」及「海外指定餐廳」名單，請參考活動網頁：<a href="https://www.americanexpress.com/zh-tw/benefits/diningbenefit/" >https://www.americanexpress.com/zh-tw/benefits/diningbenefit/</a >。名單可能隨時更改，恕美國運通不另行通知，請於使用優惠前至活動網頁確認，否則該筆之交易將不適用，恕不得要求抵用本活動之刷卡金。於日本境内的參與之餐廳，皆須事先以登錄之卡片於Pocket Concierge 進行預約並預付款項；若該餐廳不接受於Pocket Concierge預付款項，將無法獲取相關禮遇之刷卡金回饋。 </li> <li> 實際收卡情況需依照現場為主。部分餐廳若因收單作業、營業情況變更或其他刷卡機因素，而無法完成交易則不適用本活動。上述餐廳若受疫情或其他因素影響營業狀況，恕美國運通不另行通知。 </li> <li> 活動期間取消卡片、轉卡、停卡、逾期未繳或違反美國運通信用卡約定條款，美國運通將移除活動資格，不再享本活動之刷卡金回饋，未使用完之回饋金將失效，不得兌換現金或點數，或要求退款、延展或轉讓。若特約商店及持卡人涉及蓄意人為操作等不正當行為，美國運通有權排除其參與本活動及使用刷卡金外，並保留法律追訴權。 </li> <li> 刷卡金將於餐廳請款後之5 - 150個工作天內回饋至您的主卡帳上，2025年6月30日23:59／2025年12月31日23:59（台灣時間）後，未使用完之刷卡金將失效，不得兌換現金或點數，或要求退款、延展或轉讓。 </li> <li> 若退刷或取消刷卡消費，該筆刷卡金將於您的主卡帳戶扣除。若經美國運通判斷非正常使用本活動，刷卡金將被扣除，該帳戶也將不得再登錄或使用未來的優惠活動。刷卡金扣除作業將於活動結束後180天內處理，若您已交繳納該期帳單費用，刷卡金回饋扣除當期之帳單將會產生未付清之消費。 </li> <li>當您完成登錄本活動後，亦即您已同意本活動所有注意事項。</li> <li>用餐前請事先訂位，美國運通恕不保證訂位。</li> <li> 簽帳卡僅為支付工具，所有餐點、服務、諮詢及建議均由各餐廳負責提供，美國運通並非上述相關餐點及／或服務之供應者，美國運通對買賣商品或服務之瑕疵或履行並不負保證責任，亦不對其作出任何表述或保證，持卡人用餐或服務應先審慎評估。其他優惠相關規定，請依各餐廳現場規定 / 公告為準。 </li> <li> 美國運通保留修改、變更、提前終止本活動及對本活動之所有事宜做出最終解釋及決定之權利，如有不可歸責本公司之事由將依信用卡業務機構管理辦法第十九條及相關規定辦理，並提前通知。 </li> </ol> <p> <a href="https://www.americanexpress.com/zh-tw/benefits/diningbenefit/" >按此</a >瀏覽指定餐廳名單、詳細禮遇條款及細則。 </p>`,
    },
    close: "關閉",
  },
  pocket: {
    title: "Explore 800+ restaurants and book directly with Pocket Concierge",
    button: "Visit Pocket Concierge",
  },
  pocketCard: {
    title: "Pocket Concierge",
    description:
      "瀏覽與預訂日本指定餐廳（請留意，僅適用於Pocket Concierge事先預付費用之指定餐廳）",
    cuisines: "各種料理菜系",
    instruction: "如需預訂，請瀏覽：",
    button: "Visit Pocket Concierge",
  },
  footer: {
    disclaimer:
      '<p>註1：參閱活動細則與注意事項</p><p>本活動需於活動期間，以台灣美國運通發行之美國運通簽帳白金卡主卡身分登錄，刷卡金回饋將於成功登錄本活動後開始計算。</p><p>適用本活動之「全台指定餐廳」定義為該餐廳位於台灣境內。</p><p>適用本活動之「海外指定餐廳」定義為該餐廳位於台灣境外。</p><p>僅適用於收到《白金美饌‧非同凡饗》電子邀請函，並持有美國運通簽帳白金卡（不含美國運通長榮航空簽帳白金卡）之指定主卡會員。本活動將合併計算美國運通簽帳白金卡主卡及其附屬卡之合資格消費，但不含主／附屬卡會員名下之其他美國運通卡。</p><p>版權© 2025台灣美國運通國際股份有限公司保留一切權利</p>',
  },
  platinumBanner: {
    title: "簽帳白金卡專屬網站",
    text: "探索更多美國運通簽帳白金卡優惠",
    button: "立即瀏覽",
  },
};

export default lang;
